<template>
  <section class="page-banner">
    <div class="wrap">
      <div class="crumb">首页 / <b>{{ title }}</b></div>
      <h1>{{ title }}</h1>
      <p v-if="subtitle">{{ subtitle }}</p>
    </div>
  </section>
</template>

<script setup>
import { defineProps } from 'vue';

defineProps({
  // 页面标题（同时用于面包屑）
  title: {
    type: String,
    required: true,
  },
  // 页面副标题/简介
  subtitle: {
    type: String,
    default: '',
  },
});
</script>
